// removed by extract-text-webpack-plugin
module.exports = {"registration-guide":"registration-guide","guide-section":"guide-section"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Registration/subComponents/RegistrationGuide.scss
// module id = 4565
// module chunks = 1